import React from 'react'

function BrakeInString(props) {
  let str = props.text
            ? props.text
            : '';

  const element = {
    dangerouslySetInnerHTML: {
      __html: str.split('//').join('<br/>'),
    },
  };

  return React.createElement('span', element);
};

export default BrakeInString;